// Import libraries
import { useContext } from 'react';

// Import custom modules
import AuthContext from '../../providers/AuthProvider';
import { AuthContextType } from '../../providers/AuthProvider/index.d';

const useAuth = (): AuthContextType => {
  return useContext(AuthContext) as AuthContextType;
};

export default useAuth;
